import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=32ee8f16&scoped=true&lang=html&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=32ee8f16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee8f16",
  null
  
)

export default component.exports